import { useApi } from "../lib/settings";
import { fmt } from "../lib/api";
import { ImportPanel } from "./ImportPanel";
import { TranslatePanel } from "./TranslatePanel";

const Stat = ({ label, value, id }) => (
  <div className="rounded-xl border border-white/10 bg-[#0d2233] p-5" data-testid={`admin-stat-${id}`}>
    <p className="text-xs uppercase tracking-wider text-slate-300">{label}</p>
    <p className="mt-2 text-3xl font-bold text-white" style={{ fontFamily: "Oswald" }}>{Number(value || 0).toLocaleString("it-IT")}</p>
  </div>
);

export default function Dashboard() {
  const { data } = useApi("/admin/stats", []);
  const top = Array.isArray(data?.top) ? data.top : [];
  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <h1 className="text-3xl font-bold text-white" style={{ fontFamily: "Oswald" }}>Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-4">
        <Stat id="games" label="Giochi totali" value={data?.games} />
        <Stat id="published" label="Pubblicati" value={data?.published} />
        <Stat id="featured" label="In evidenza" value={data?.featured} />
        <Stat id="categories" label="Categorie" value={data?.categories} />
        <Stat id="plays" label="Partite giocate" value={data?.plays} />
        <Stat id="likes" label="Mi piace" value={data?.likes} />
      </div>
      <ImportPanel />
      <TranslatePanel />
      <div className="rounded-xl border border-white/10 bg-[#0d2233] p-5">
        <h2 className="text-lg font-bold text-white mb-4">Giochi più giocati</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {top.map((g) => (
            <a key={g.slug} href={`/gioco/${g.slug}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-lg bg-white/5 p-2 hover:bg-white/10">
              <img src={g.image} alt="" className="w-16 h-12 object-cover rounded" />
              <div className="min-w-0">
                <p className="text-sm text-white truncate">{g.title}</p>
                <p className="text-xs text-slate-300">{fmt(g.plays)} partite</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
